import {ChangeDetectionStrategy, Component, computed, input, OnInit} from "@angular/core";
import {Fumigation, FumigationStevedore} from "@portbase/bezoekschip-service-typescriptmodels";
import {VisitContext} from "../../../../../visit-context";
import {PortvisitUtils} from "../../../../../../refdata/portvisit-utils";
import {Observable} from "rxjs";
import {sendQuery} from "../../../../../../common/utils";

@Component({
  selector: 'app-fumigation-stevedore',
  templateUrl: './fumigation-stevedore.component.html',
  styleUrls: ['./fumigation-stevedore.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FumigationStevedoreComponent implements OnInit {

  context = VisitContext;
  portVisitUtils = PortvisitUtils;

  fumigation = input<Fumigation>();
  portCode = input<string>();

  fumigationStevedoreCompanies : Observable<FumigationStevedore[]>;

  ngOnInit() {
    this.setStevedoreCompanies();
  }

  setStevedoreCompanies() {
    const portCode = this.context.visit.portOfCall.port.locationUnCode;
    this.fumigationStevedoreCompanies = sendQuery('com.portbase.bezoekschip.common.api.dangerousgoods.GetFumigationStevedores', {
      portCode: portCode
    });
  }

  isOtherStevedoreCompany = computed(() =>
    this.fumigation().stevedoreCompany?.name === 'Other'
  );
}
